module.exports = __webpack_public_path__ + "media/images/iconSocialShare__inactive-b48c2a2984262b8fad9eca9788c98fcb.png";